const DefaultProcurementExcelColumnEN = [
  'productTitle',
  'productPrice',
  'requestedTotalUnit',
  'totalUnit',
  'position',
];

const DefaultProcurementExcelColumnMN = [
  'Барааны нэр',
  'Барааны үнэ',
  'Үүссэн тоо',
  'Хүлээн авсан тоо',
  'ThirdParty код',
];
export { DefaultProcurementExcelColumnEN, DefaultProcurementExcelColumnMN };
